module.exports = __webpack_public_path__ + "img/report-7.69572213.jpg";